<template>
  <div>
    <el-form :inline="true" class="form">
      <!-- 查询时间 -->
      <el-form-item :label='$t("time.timeQuery")' class="selectIcon">
        <el-select v-model="searchType" style="width:140px" :size="size">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="searchType == 0">
        <!-- 常规查询 -->
        <el-date-picker :size="size" style="width:285px"
          v-model="searchMTime"
          type="monthrange"
          value-format="yyyy-MM"
          :picker-options="monthPickerOptions"
          :range-separator='$t("time.to")'
          :start-placeholder='$t("time.startMonth")'
          :end-placeholder='$t("time.endMonth")'>
        </el-date-picker>
      </el-form-item>
      <el-form-item v-else>
        <!-- 快捷查询 -->
        <el-button 
          v-for="item in monthBtns"
          :key="item.value"
          :type="showMBtn == item.value ? 'primary' :''" 
          :size="size"
          style="text-align:center;"
          @click="quickQuery(item.value)"
        >{{item.label}}</el-button>
      </el-form-item>
      <!-- 查询 -->
      <el-form-item v-if="searchType == 0">
        <el-button 
          type="primary" 
          
          :size="size"
          style="margin-left:8px;"
          @click="handleQuery"
        >{{ $t("public.query")}}</el-button>
      </el-form-item>
      <!-- 导出 -->
      <el-form-item>
        <el-button 
          :size="size"
          type="primary"  plain 
          style="margin-left:10px"
          @click="download"
          :loading="downloading"
        >{{ $t("public.export")}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props:{
    size:{
      type: String,
    },
    isNow:{
      type: Boolean,
      default: true
    },
    downloading:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      showMBtn:undefined,
      monthBtns:[],
      searchType:0,
      options:[],
      searchMTime:[],
      monthPickerOptions:{
        disabledDate(date) {
          var t = new Date();
          var n = new Date(t.getFullYear(), t.getMonth(), 1);

          return date > new Date(n.getTime())
        }
      }
    }
  },
  methods:{
    handleQuery(){
      if(this.searchMTime == null || this.searchMTime == undefined || this.searchMTime == ''){
        this.$emit("handleQuery",{"beginDate":"","endDate":""});
        return;
      }
      const nowMonth = new Date().getMonth();
      var selectMonth = new Date(this.moment(this.searchMTime[1]).format("YYYY-MM-DD")).getMonth();
      // console.log(this.moment(this.searchMTime[0]).format("YYYY-MM-01"));
      // console.log(this.moment(this.searchMTime[1]).format("YYYY-MM-DD"));
      if(selectMonth == nowMonth){
        //选择的月份范围是到当月的
        // this.searchMTime[1] = new Date();
        let itemSearMTime = new Date();//不直接修改searchMTime[1]的值，会报错
        this.$emit("handleQuery",{"beginDate":this.moment(this.searchMTime[0]).format("YYYY-MM-01"),"endDate":this.moment(itemSearMTime).format("YYYY-MM-DD")})
      }else{
        //选择月份范围不包括当月
        var monthDay = this.getCountDays(this.moment(this.searchMTime[1]).format("YYYY-MM-DD"));
        this.$emit("handleQuery",{"beginDate":this.moment(this.searchMTime[0]).format("YYYY-MM-01"),"endDate":this.moment(this.searchMTime[1]).format("YYYY-MM-" + monthDay)})
        
      }
    },
    download(){
      this.$emit("download");
    },
    quickQuery(val){
      
      this.showMBtn = val;

      let day = 24 * 60 * 60 * 1000;
      let getDay = new Date().getDay();
      let getNowMonth = new Date().getMonth() + 1 + "";
      getNowMonth = getNowMonth.length == 2 ? getNowMonth : ("00" + getNowMonth).substring(("" + getNowMonth).length); 
      let getLastMonth = new Date().getMonth() + "";
      getLastMonth = getLastMonth.length == 2 ? getLastMonth : ("00" + getLastMonth).substring(("" + getLastMonth).length); 
      let today = new Date();
      switch(val){
        case 0: //本月
          this.beginDate = this.format(new Date(),"yyyy-" + getNowMonth + "-01");
          this.endDate = this.format(new Date(),"yyyy-" + getNowMonth + "-" + this.getCountDays(this.beginDate) );
          // console.log(this.beginDate,this.endDate);
          break;
        case 1:  //上月
          //跨年特殊处理
          if(getLastMonth == "00"){
            this.beginDate = this.format(new Date(),today.getFullYear()-1 + "-12-01");
            this.endDate = this.format(new Date(),today.getFullYear()-1 + "-12-31");
          }else{
            this.beginDate = this.format(new Date(),"yyyy-" + getLastMonth + "-01");
            this.endDate = this.format(new Date(),"yyyy-" + getLastMonth + "-" + this.getCountDays(this.beginDate));
          }
          // console.log(this.beginDate,this.endDate);
          break;
        case 2:  //上上月
          let month = new Date().getMonth() - 1 + "";
          month = month.length == 2 ? month : ("00" + month).substring(("" + month).length); 
          //跨年特殊处理
          if(month == "-1"){
            this.beginDate = this.format(new Date(),today.getFullYear()-1 + "-11-01");
            this.endDate = this.format(new Date(),today.getFullYear()-1 + "-11-30");
          }else if(month == "00"){
            this.beginDate = this.format(new Date(),today.getFullYear()-1 + "-12-01");
            this.endDate = this.format(new Date(),today.getFullYear()-1 + "-12-31");
          }else{
            this.beginDate = this.format(new Date(),"yyyy-" + month + "-01");
            this.endDate = this.format(new Date(),"yyyy-" + month + "-" + this.getCountDays(this.beginDate));
          }
          // console.log(this.beginDate,this.endDate);
          break;
      }
      this.$emit("quickQuery",{"beginDate": this.beginDate,"endDate":this.endDate})
    },
    format(datetime, format) {
      var o = {
        "M+": datetime.getMonth() + 1, //month
        "d+": datetime.getDate(), //day
        "h+": datetime.getHours(), //hour
        "m+": datetime.getMinutes(), //minute
        "s+": datetime.getSeconds(), //second
        "q+": Math.floor((datetime.getMonth() + 3) / 3), //quarter
        S: datetime.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          /(y+)/.exec(format)[0],
          (datetime.getFullYear() + "").substring(4 - /(y+)/.exec(format)[0].length)
        );
      }

      for (var k in o) {
        // console.log(o[k]);
        if (new RegExp("(" + k + ")").test(format)) {
          let item = eval("/(" + k +")/.exec(format)[0]")
          format = format.replace(
            item,
            item.length == 1 ? o[k] : ("00" + o[k]).substring(("" + o[k]).length)
          );
        // console.log(format,"0.0");
        }
      }
      return format;
    },
    // 获取一个月有多少天，curDate是开始日期，获取这个日期的月份的天数
    getCountDays(curDate) {
      const d = new Date(curDate)
      const y = d.getFullYear()
      //获取本月的下一个月
      const m = d.getMonth() + 1 
      // 下一个月的第0天就是这个月的天数
      const days = new Date(y, m, 0).getDate()
      return days
    },
  },
  mounted(){
    let t = new Date();
    var n = new Date(t.getFullYear(), t.getMonth()-2, 1);
    this.searchMTime = [new Date(n),new Date];
    this.options = [
      {
        value:0,
        label:this.$t("time.generalQuery")
      },
      {
        value:1,
        label:this.$t("time.quickQuery"),
      }
    ];
    this.monthBtns = [
      // {
      //   value:0,
      //   label:this.$t("time.thisMonth"),
      // },
      {
        value:1,
        label:this.$t("time.lastMonth"),
      },
      {
        value:2,
        label:this.$t("time.twoMonthsGgo"),
      },
    ];
    //加不加本月
    if(this.isNow){
      this.monthBtns.unshift(
        {
          value:0,
          label:this.$t("time.thisMonth"),
        },
      )
    }
    this.handleQuery();
  }
}
</script>
<style lang="scss" scoped>
.form  {
  ::v-deep .el-form-item {
      margin-bottom: 0px !important;
  }
}
  

</style>